import { render } from "./realTimeData.vue?vue&type=template&id=f148593a&scoped=true"
import script from "./realTimeData.vue?vue&type=script&lang=js"
export * from "./realTimeData.vue?vue&type=script&lang=js"

import "./realTimeData.vue?vue&type=style&index=0&id=f148593a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f148593a"],['__file',"src/views/data/components/realTimeData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f148593a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f148593a', __exports__)) {
    console.log('reload')
    api.reload('f148593a', __exports__)
  }
  
  module.hot.accept("./realTimeData.vue?vue&type=template&id=f148593a&scoped=true", () => {
    console.log('re-render')
    api.rerender('f148593a', render)
  })

}


export default __exports__